const SENTRY_BUNDLE_URL = 'https://browser.sentry-cdn.com/7.120.2/bundle.tracing.min.js';

const loadScript = (src) => new Promise((resolve, reject) => {
  const existing = document.querySelector(`script[data-src="${src}"]`);
  if (existing) {
    resolve();
    return;
  }
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.setAttribute('data-src', src);
  script.onload = () => resolve();
  script.onerror = () => reject(new Error(`Failed loading script: ${src}`));
  document.head.appendChild(script);
});

export async function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.Sentry?.isInitialized?.()) return;

  try {
    await loadScript(SENTRY_BUNDLE_URL);
    if (!window.Sentry) return;
    window.Sentry.init({
      dsn,
      integrations: window.Sentry.BrowserTracing ? [new window.Sentry.BrowserTracing()] : [],
      tracesSampleRate: 0.1,
      environment: process.env.NODE_ENV || 'development',
      release: process.env.REACT_APP_RELEASE || undefined,
    });
  } catch (_err) {
    // Sentry is optional. Ignore setup failures so app boot does not break.
  }
}
